import httpClient from "../Core/http";

class MachinePictures_Api {
  getMachinePictures(params: any): Promise<any> {
    let url = "machine/pictures";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
    async loadCsrfToken(): Promise<string> {
        const res = await httpClient.get("/auth/token", {
            withCredentials: true
        });

        return res.data.token; 
    }
}

export const MachinePicturesApi = new MachinePictures_Api();
